
import axios from 'axios';
import React from "react";
import { connect } from "react-redux";
import history from "../../auth/history";
import XMLParser from 'react-xml-parser';
import { v4 as uuidv4 } from 'uuid';
import { store } from "../../redux/store";
import $ from 'jquery';
import { setOtpResponse } from "../../redux/misc-data/misc-data.action";
import { setAgentInfo } from './../../redux/misc-data/misc-data.action';
// import RdServices from "react-native-rd-services";
import { checkingDriverStatus, setBiometricDta, setBiometricDtaCaptureStatus, setCaptureUrl, setDeviceInfoUrl } from '../../redux/aeps/aeps.action';
import swal from 'sweetalert';

var finalUrl = "";
var MethodInfo = "";
var MethodCapture = "";
var finalport = "";
var is_capture = false;
var finalRdServiceResponse = [];
var btnText = '';
var biomatricIndicater = '';
var deviceInfo = '';
var deviceErrorMsg = '';
var deviceErrorCode = '';
var capturedData = '';

var url = '';
var OldPort = true;
var count = 0;


const httpClient = axios.create();
class BioMetryCapture extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: '',
            refId: '',
            shopName: '',
            mobile: '',
            otpToken: '',
            kycToken: '',
            wadh: '',
            captureStatus: 'Off',
            version: '',
            serialNum: '',
            timeStamp: '',
            deviceXmlData: '',
            biomatricDeviceIndicaterClass: '',
            biomatricDeviceIndicater: '',
            submitBtnStatus: false,
            aadharNumber: '',
            req: '',
            discovrRdServiceRes:[]
        }
    }

    captureDeviceInfoOnLoad() {



        this.discoverRDService();


    }


    discoverRDService = () => {
        // Search for the valid RDService from port 11100 to 11120
        var primaryUrl = 'http://127.0.0.1:';//"http://127.0.0.1:";
        //   alert(primaryUrl);
        var tempcount = 0;
        var url = "";
        $("#ddlRDS").empty();
        //alert("Discovering Precision RDService.\nPlease wait for some time.");

        var curPort = 11100;
        var xmlstr = '';
        for (var i = 11100; i <= 11105; i++) {
            var verb = "RDSERVICE";
            var err = "";

            //alert(i);
            var res;
            $.support.cors = true;
            var httpStaus = false;
            var jsonstr = "";
            var data = new Object();
            var obj = new Object();
            var xmlstr;
            console.log("primaryUrl_____", primaryUrl + i.toString())
            $.ajax({
                type: "RDSERVICE",
                async: false,
                crossDomain: true,
                url: primaryUrl + i.toString(),
                contentType: "text/xml; charset=UTF-8",
                processData: false,
                cache: false,
                timeout: 200,

                success: function (data) {

                    if (typeof data == 'object' || typeof data == 'Object') {
                        xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                    }
                    if (typeof data == 'string') {
                        xmlstr = data;
                    }

                    console.log("xmlstr___xmlstr", xmlstr);


                    try {

                        data = xmlstr;


                        httpStaus = true;
                        res = { httpStaus: httpStaus, data: data };

                        var deviceDataInJson = new XMLParser().parseFromString(xmlstr);

                        var deviceDataInJsonChildren = deviceDataInJson.children;

                        var captureUrl = '';
                        var deviceInfoUrl = '';

                        // if (deviceDataInJson.attributes.status == 'NOTREADY') {
                        //     //sweetaler
                        //     swal({
                        //         title: "Error!",
                        //         text: 'Device not ready',
                        //         icon: "warning",
                        //         button: true,
                        //         dangerMode: false,
                        //     })
                        //         .then(() => {
                        //         });

                        // }
                        this.state.discovrRdServiceRes.push(deviceDataInJson.attributes.status);

                        if (deviceDataInJson.attributes.status == 'READY') {
                            if (deviceDataInJsonChildren.length > 0) {
                                deviceDataInJsonChildren.map(deviceDataInJsonChild => {
                                    if (deviceDataInJsonChild.attributes.id == 'CAPTURE') {
                                        captureUrl = deviceDataInJsonChild.attributes.path;

                                        if (!captureUrl.includes('127.0.0.1')) {

                                            captureUrl = 'http://127.0.0.1:' + i + captureUrl
                                        } else {
                                            if (!captureUrl.includes('http://')) {

                                                if (captureUrl.substring(0, 1) == '/') {
                                                    captureUrl = 'http:/' + captureUrl
                                                } else {
                                                    captureUrl = 'http://' + captureUrl
                                                }

                                            }
                                        }

                                        store.dispatch(setCaptureUrl(captureUrl))
                                    }
                                    if (deviceDataInJsonChild.attributes.id == 'DEVICEINFO') {
                                        deviceInfoUrl = deviceDataInJsonChild.attributes.path;
                                        if (!deviceInfoUrl.includes('127.0.0.1')) {

                                            deviceInfoUrl = 'http://127.0.0.1:11100' + deviceInfoUrl
                                        } if (!deviceInfoUrl.includes('http://')) {
                                            if (deviceInfoUrl.substring(0, 1) == '/') {
                                                deviceInfoUrl = 'http:/' + deviceInfoUrl
                                            } else {
                                                deviceInfoUrl = 'http://' + deviceInfoUrl
                                            }

                                        }
                                        store.dispatch(setDeviceInfoUrl(deviceInfoUrl))
                                    }

                                })
                            }

                        }else{

                        }



                        var httpStaus = true;
                        res = { httpStaus: httpStaus, data: xmlstr };

                        var discoverRdServiceStatus = '';
                        var discoverRDServiceFinalResponse = '';

                        if (res.data != '') {
                            if (res.data == 'error') {
                                discoverRdServiceStatus = 'ERROR';
                            } else {
                                discoverRDServiceFinalResponse = new XMLParser().parseFromString(res.data);
                            }
                        }

                        var info = discoverRDServiceFinalResponse != '' && discoverRDServiceFinalResponse.attributes.info != undefined ? discoverRDServiceFinalResponse.attributes.info : '';
                        if (discoverRdServiceStatus != 'ERROR') {
                            discoverRdServiceStatus = discoverRDServiceFinalResponse != '' && discoverRDServiceFinalResponse.attributes.status != undefined ? discoverRDServiceFinalResponse.attributes.status : '';//"NOTREADY"
                        }
                        console.log("discoverRDServiceFinalResponse1__", discoverRDServiceFinalResponse.attributes);
                        store.dispatch(checkingDriverStatus(discoverRdServiceStatus));
                        finalUrl = primaryUrl + i.toString();
                        tempcount++;
                    }
                    catch (e) { }
                },
                error: function (msg) {
                    // // alert(JSON.stringify(msg))
                    var httpStaus = false;
                    res = { httpStaus: false, data: 'error' };
                    // alert('driver checking response: ' + JSON.stringify(res));
                    var discoverRdServiceStatus = '';
                    var discoverRDServiceFinalResponse = '';

                    if (res.data != '') {
                        if (res.data == 'error') {
                            discoverRdServiceStatus = 'ERROR';
                        } else {
                            discoverRDServiceFinalResponse = new XMLParser().parseFromString(res.data);
                        }
                    }

                    var info = discoverRDServiceFinalResponse != '' && discoverRDServiceFinalResponse.attributes.info != undefined ? discoverRDServiceFinalResponse.attributes.info : '';
                    if (discoverRdServiceStatus != 'ERROR') {
                        discoverRdServiceStatus = discoverRDServiceFinalResponse != '' && discoverRDServiceFinalResponse.attributes.status != undefined ? discoverRDServiceFinalResponse.attributes.status : '';//"NOTREADY"
                    }

                    console.log("discoverRDServiceFinalResponse2__", discoverRDServiceFinalResponse.attributes);

                    store.dispatch(checkingDriverStatus(discoverRdServiceStatus));

                }

            });



            if (xmlstr != null && xmlstr != undefined && xmlstr != '') {


                $("select#ddlRDS").prop('selectedIndex', tempcount - 1);
                finalport = i.toString();

                break;

            }

        }
        return this.state.discovrRdServiceRes;

    }
    captureData(captureUrl, deviceInfoUrl) {
        console.log('calling capturefingerprint3');
        // this.setState({ submitBtnStatus: true });
        setTimeout(() => {

            this.capture(captureUrl)
        }, 100);

    }


    captureFingerPrint = async (captureUrl, deviceInfoUrl) => {
        console.log('calling capturefingerprint2');
        this.captureData(captureUrl, deviceInfoUrl);

    }


    capture = (captureUrl) => {						// Get Capture Info from the path given by RDService Info

        // var fCount = document.getElementById('txtfcount').value;
        // var fType = 1;//document.getElementById('txtftype').value;
        // var format = document.getElementById('txtformat').value;
        // var pidver = document.getElementById('txtPidVer').value;
        // var timeout = document.getElementById('txttimeout').value;
        // var env = document.getElementById('txtenv').value;
        // var lock = document.getElementById('txtlk').value;
        // var iCount = 0;
        // var iType = "";
        // var pType = "";
        // var pCount = 0;
        // var wadh_value = document.getElementById('wadh_value').value;
        var xmlstr;

        console.log('calling capturefingerprint4');
        var XML = '';
        if (process.env.REACT_APP_ENV == 'UAT') {
            XML = '<PidOptions ver=\"1.0\"><Opts fCount=\"1\" fType=\"0\" format=\"0\" pidVer=\"2.0\" wadh=\"\" timeout=\"20000\" env=\"PP\"/></PidOptions>';
        }
        if (process.env.REACT_APP_ENV == 'PROD') {
            XML = '<PidOptions ver=\"1.0\"><Opts fCount=\"1\" fType=\"0\" format=\"0\" pidVer=\"2.0\" wadh=\"\" timeout=\"20000\" env=\"P\"/></PidOptions>';
        }
        console.log("XML_data_", XML);
        var verb = "CAPTURE";
        var err = "";
        var res;
        $.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        $.ajax({
            type: "CAPTURE",
            async: false,
            crossDomain: true,
            // url: finalUrl + MethodCapture,
            url: captureUrl,
            data: XML,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            success: function (data) {
                if (typeof data == 'object' || typeof data == 'Object') {
                    xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                }
                if (typeof data == 'string') {
                    xmlstr = data;
                }



                //alert(xmlstr);
                data = xmlstr;
                //alert(data);
                httpStaus = true;
                var isBiomatric = true;
                res = { httpStaus: httpStaus, data: data };
                finalRdServiceResponse = data;
                $('#txtPidData').val(data);
                $('#txtPidOptions').val(XML);
                var deviceErrorMsg = $($doc).find('Resp').attr('errInfo');
                deviceErrorCode = 0;
                var $doc = $.parseXML(data);
                var Message = $($doc).find('Resp').attr('errInfo');

                var captureDatainJson = new XMLParser().parseFromString(data);
                var errCode = captureDatainJson.children[0].attributes.errCode;

                if (errCode == 0) {

                    store.dispatch(setBiometricDta(btoa(data)));
                    store.dispatch(setBiometricDtaCaptureStatus('success'));
                    //sweetaler
                    swal({
                        title: "Success!",
                        text: "Finger Print captured successfully.",
                        icon: "success",
                        button: true,
                        dangerMode: false,
                    })
                        .then(() => {
                        });



                    // store.dispatch(setBioMetricEncryptionXML({ bioMetricEncryptionXML: captureData.data }));

                    var xmlDta = data;


                } else {
                    // var errInfo = Fingerprintxml.children[0].attributes.errInfo != undefined ? Fingerprintxml.children[0].attributes.errInfo : '';
                    store.dispatch(setBiometricDtaCaptureStatus('failed'));
                    //sweetaler
                    swal({
                        title: "Error!",
                        text: 'Error',
                        icon: "warning",
                        button: true,
                        dangerMode: false,
                    })
                        .then(() => {
                        });

                }
            },
            error: function (msg) {
                var result = msg.status + msg.statusText + msg.responseText;
                res = { httpStaus: false, data: result };

                var deviceErrorMsg = "Please reconnect biomatric device.";
                deviceErrorCode = 1;
                console.log("Error in Finger print capture ", res);

            }
        });

        if (deviceErrorCode === 1) {

            swal({
                title: "Error!",
                text: 'Error',
                icon: "warning",
                button: true,
                dangerMode: false,
            })
                .then(() => {
                });

        }

        this.setState({ isBiomatricConnected: false });

        //  return false;
        return res;



    }




    capture2 = (captureUrlVal, deviceInfoUrl) => {						// Get Capture Info from the path given by RDService Info
        // Get Capture Info from the path given by RDService Info
        var fCount = '1';
        var fType = 1;//document.getElementById('txtftype').value;
        // var fType = 'X';//document.getElementById('txtftype').value;
        var format = '0';
        var pidver = '2.0';
        var timeout = '10000';



        var env = 'PP';
        var lock = "";
        var iCount = 0;
        var iType = "";
        var pType = "";
        var pCount = 0;

        // finalUrl = 'http://127.0.0.1:11100' + captureUrlVal;
        finalUrl = captureUrlVal;
        console.log("Capture_", finalUrl);

        var envVal = '';
        // alert(process.env.REACT_APP_ENV)
        var XML = '';
        if (process.env.REACT_APP_ENV == 'UAT') {
            XML = '<PidOptions ver=\"1.0\"><Opts fCount=\"1\" fType=\"0\" format=\"0\" pidVer=\"2.0\" wadh=\"\" timeout=\"20000\" env=\"PP\"/></PidOptions>';
        }
        if (process.env.REACT_APP_ENV == 'PROD') {
            XML = '<PidOptions ver=\"1.0\"><Opts fCount=\"1\" fType=\"0\" format=\"0\" pidVer=\"2.0\" wadh=\"\" timeout=\"20000\" env=\"P\"/></PidOptions>';
        }

        console.log("XML_data_", XML);

        var xhr;
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        xhr = new XMLHttpRequest();
        xhr.open('CAPTURE', finalUrl, true);
        xhr.setRequestHeader("Content-Type", "text/xml");
        xhr.setRequestHeader("Accept", "text/xml");

        xhr.onreadystatechange = function () {
            if (xhr.readyState == 1 && count == 0) {
                this.fakeCall(deviceInfoUrl);
            }
            if (xhr.readyState == 4) {
                var status = xhr.status;
                //parser = new DOMParser();
                if (status == 200) {
                    var test1 = xhr.responseText;
                    var test2 = test1.search("errCode");
                    var test6 = test1.split('"', 2).join('"').length;
                    var test4 = test2 + 9;
                    var test5 = test1.slice(test4, test6);
                    if (test5 > 0) {
                        // alert("capture error:"+xhr.responseText);
                        var captureDatainJson = new XMLParser().parseFromString(xhr.responseText);
                        var errCode = captureDatainJson.children[0].attributes.errCode;
                        if (errCode != '0') {
                            //sweetaler
                            swal({
                                title: "Error!",
                                text: captureDatainJson.children[0].attributes.errInfo,
                                icon: "warning",
                                button: true,
                                dangerMode: false,
                            })
                                .then(() => {
                                });
                        }
                    }
                    else {

                        var captureData = xhr.response;

                        console.log("captureData___", captureData);
                        var captureDatainJson = new XMLParser().parseFromString(captureData);
                        // alert(JSON.stringify(captureDatainJson))


                        var Fingerprintxml = new XMLParser().parseFromString(captureData);

                        Fingerprintxml.children[2].attributes.ci = "20231023";
                        console.log("Fingerprintxml ff", Fingerprintxml);
                        var errCode = Fingerprintxml.children[0].attributes.errCode != undefined ? Fingerprintxml.children[0].attributes.errCode : '';




                        var versionV = Fingerprintxml.children[1].attributes.rdsVer
                        var serialNumV = Fingerprintxml.children[1].children[0].children[0].attributes.value
                        var timeStampV = Fingerprintxml.children[1].children[0].children[1].attributes.value


                        //console.log("Fingerprintxml_data_",Fingerprintxml.children[0].attributes.errCode);
                        if (errCode == 0) {

                            //sweetaler
                            swal({
                                title: "Success!",
                                text: "Finger Print captured successfully.",
                                icon: "success",
                                button: true,
                                dangerMode: false,
                            })
                                .then(() => {
                                });



                            // store.dispatch(setBioMetricEncryptionXML({ bioMetricEncryptionXML: captureData.data }));

                            var xmlDta = captureData;
                            store.dispatch(setBiometricDta(btoa(xmlDta)));
                            store.dispatch(setBiometricDtaCaptureStatus('success'));

                        } else {
                            var errInfo = Fingerprintxml.children[0].attributes.errInfo != undefined ? Fingerprintxml.children[0].attributes.errInfo : '';
                            store.dispatch(setBiometricDtaCaptureStatus('failed'));
                            //sweetaler
                            swal({
                                title: "Error!",
                                text: errInfo,
                                icon: "warning",
                                button: true,
                                dangerMode: false,
                            })
                                .then(() => {
                                });

                        }
                    }
                } else {

                    console.log(xhr.response);

                }

            };



        }
        xhr.send(XML);
    }


    //rd service

    discoverFirstNode = (PortNo) => {				// Get the Status of the RDService found by discoverRDService()
        $('#txtDeviceInfo').val('');
        $('#txtPidOptions').val('');
        $('#txtPidData').val('');

        //alert(PortNo);

        var primaryUrl = 'http://127.0.0.1:';//"http://127.0.0.1:";
        let url = "";
        var verb = "RDSERVICE";
        var err = "";
        var res;
        $.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        var data = new Object();
        var obj = new Object();

        $.ajax({
            type: "RDSERVICE",
            async: false,
            crossDomain: true,
            url: primaryUrl + PortNo,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            cache: false,
            async: false,
            crossDomain: true,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                //alert(xmlstr);
                data = xmlstr;
                //alert(data);
                httpStaus = true;
                res = { httpStaus: httpStaus, data: data };
                //alert(data);		
                $('#txtRDSInfo').val(data);

                var $doc = $.parseXML(data);

                for (var j = 0; j < 2; j++) {
                    if ($($doc).find('Interface').eq(j).attr('id') == 'CAPTURE') {
                        MethodCapture = $($doc).find('Interface').eq(j).attr('path');
                    } else if ($($doc).find('Interface').eq(j).attr('id') == 'DEVICEINFO') {
                        MethodInfo = $($doc).find('Interface').eq(j).attr('path');
                    }
                }

                console.log(" RDSERVICE Discover Successfully");
                var parser = new DOMParser();
                var device1_response = parser.parseFromString($doc, "text/xml");
                // var biomatricIndicater='';biomatricDeviceIndicater
                //console.log("doc1___",reMethodCaptures," MethodInfo_"+MethodInfo);
                // biomatricIndicater = "Biometric device connected, scan fingerprint of the customer for Aadhaar authentication";
                is_capture = true;
            },
            error: function (msg) {
                is_capture = false;
                var result = msg.status + msg.statusText + msg.responseText;
                // alert('result:' + result);

            }
        });
        this.deviceInfo();
        this.deviceInfo2();

        return res;

    }

    deviceInfo = () => {
        var url = "";
        finalUrl = 'http://127.0.0.1:' + finalport;
        var verb = "DEVICEINFO";
        //alert(finalUrl);

        var err = "";
        var res;
        //$.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        $.ajax({
            type: "DEVICEINFO",
            async: false,
            crossDomain: true,
            url: finalUrl + MethodInfo,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                //alert(xmlstr);
                data = xmlstr;
                //alert(url);
                httpStaus = true;
                res = { httpStaus: httpStaus, data: data };

                $('#txtDeviceInfo').val(data);
                deviceInfo = data;
            },
            error: function (msg) {
                var result = msg.status + msg.statusText + msg.responseText;
                console.log("Error In device info", result);

            }
        });

        return res;


    }
    rdService2 = () => {
        var url = "http://127.0.0.1:11100";

        var xhr;
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        var res = '';
        // if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer, return version number
        // {
        //     //IE browser
        //     xhr = new ActiveXObject("Microsoft.XMLHTTP");
        // } else {
        //     //other browser
        //     xhr = new XMLHttpRequest();
        // }



        xhr = new XMLHttpRequest();
        xhr.open('RDSERVICE', url, false);

        xhr.onreadystatechange = function () {
            // if(xhr.readyState == 1 && count == 0){
            // 	this.fakeCall();
            // }
            if (xhr.readyState == 4) {
                var status = xhr.status;

                if (status == 200) {
                    console.log(xhr.response);

                    var deviceDataInJson = new XMLParser().parseFromString(xhr.response);
                    var deviceDataInJsonChildren = deviceDataInJson.children;

                    var captureUrl = '';
                    var deviceInfoUrl = '';


                    if (deviceDataInJsonChildren.length > 0) {
                        deviceDataInJsonChildren.map(deviceDataInJsonChild => {
                            if (deviceDataInJsonChild.attributes.id == 'CAPTURE') {
                                captureUrl = deviceDataInJsonChild.attributes.path;
                                store.dispatch(setCaptureUrl(captureUrl))
                            }
                            if (deviceDataInJsonChild.attributes.id == 'DEVICEINFO') {
                                deviceInfoUrl = deviceDataInJsonChild.attributes.path
                                store.dispatch(setDeviceInfoUrl(deviceInfoUrl))
                            }
                        })
                    }

                    // alert(captureUrl + ':' + deviceInfoUrl)

                    var httpStaus = true;
                    res = { httpStaus: httpStaus, data: xhr.response };
                    var discoverRdServiceStatus = '';
                    var discoverRDServiceFinalResponse = '';

                    if (res.data != '') {
                        if (res.data == 'error') {
                            discoverRdServiceStatus = 'ERROR';
                        } else {
                            discoverRDServiceFinalResponse = new XMLParser().parseFromString(res.data);
                        }
                    }

                    var info = discoverRDServiceFinalResponse != '' && discoverRDServiceFinalResponse.attributes.info != undefined ? discoverRDServiceFinalResponse.attributes.info : '';
                    if (discoverRdServiceStatus != 'ERROR') {
                        discoverRdServiceStatus = discoverRDServiceFinalResponse != '' && discoverRDServiceFinalResponse.attributes.status != undefined ? discoverRDServiceFinalResponse.attributes.status : '';//"NOTREADY"
                    }

                    console.log("discoverRDServiceFinalResponse1__", discoverRDServiceFinalResponse.attributes);

                    store.dispatch(checkingDriverStatus(discoverRdServiceStatus));

                    // this.deviceInfo2();
                } else {
                    // alert(status)
                    var httpStaus = false;
                    res = { httpStaus: false, data: 'error' };
                    var discoverRdServiceStatus = '';
                    var discoverRDServiceFinalResponse = '';

                    if (res.data != '') {
                        if (res.data == 'error') {
                            discoverRdServiceStatus = 'ERROR';
                        } else {
                            discoverRDServiceFinalResponse = new XMLParser().parseFromString(res.data);
                        }
                    }

                    var info = discoverRDServiceFinalResponse != '' && discoverRDServiceFinalResponse.attributes.info != undefined ? discoverRDServiceFinalResponse.attributes.info : '';
                    if (discoverRdServiceStatus != 'ERROR') {
                        discoverRdServiceStatus = discoverRDServiceFinalResponse != '' && discoverRDServiceFinalResponse.attributes.status != undefined ? discoverRDServiceFinalResponse.attributes.status : '';//"NOTREADY"
                    }

                    console.log("discoverRDServiceFinalResponse2__", discoverRDServiceFinalResponse.attributes);

                    store.dispatch(checkingDriverStatus(discoverRdServiceStatus));
                }


                // return status;
            }

        }
        xhr.send();
        // return res;
    }

    deviceInfo2 = () => {
        // var url = "http://127.0.0.1:11100/getDeviceInfo";
        var url = "http://127.0.0.1:11100/rd/info";

        var xhr;
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");


        xhr = new XMLHttpRequest();
        //
        xhr.open('DEVICEINFO', url, true);

        xhr.onreadystatechange = function () {
            if (xhr.readyState == 1 && count == 0) {
                this.fakeCall();
            }
            if (xhr.readyState == 4) {
                var status = xhr.status;

                if (status == 200) {



                    // alert('xhr response:' + xhr.response);
                    console.log('xhr response:' + xhr.response);

                    deviceInfo = xhr.response;

                } else {

                    console.log(xhr.response);

                }
            }

        };

        xhr.send();

    }


    fakeCall(deviceInfoUrl) {
        var xhr1;
        var url = 'http://127.0.0.1:11100' + deviceInfoUrl;

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");


        xhr1.open('DEVICEINFO', url, true);
        xhr1.send();
        count = 1;
        xhr1.onreadystatechange = function () {
            if (xhr1.readyState == 4) {
                xhr1.abort();
            }
        };
    }

}


export default new BioMetryCapture();